import React, { ReactElement, ReactNode } from 'react';
import { GetSchoolResponse } from 'services/api';
import { useProfile } from 'hooks';
import { ForYouShell } from '../../ForYouShell';
import { ForYouTabKey } from '../SubNav';
import { useBrowseSidebar } from '../../useBrowseSidebar';
import { OrgsBrowse } from './OrgsBrowse';

export interface OrganizationsPageProps {
  slug: string | null;
  school?: GetSchoolResponse;
  tabs?: ForYouTabKey[];
  topBanner?: ReactNode;
}

export const OrganizationsPage = ({
  school,
  tabs,
  topBanner,
}: OrganizationsPageProps): ReactElement => {
  const { profile } = useProfile();
  const { desktopSidebar, banner, mobileBefore, mobileAfter } =
    useBrowseSidebar(school);

  return (
    <ForYouShell
      activeTab="organizations"
      documentTitle="CampusLush | Organizations"
      desktopSidebar={desktopSidebar}
      mobileBanner={banner}
      bleedMobileBanner
      mobileBefore={mobileBefore}
      mobileAfter={mobileAfter}
      tabs={tabs}
      topBanner={topBanner}
    >
      <OrgsBrowse schoolId={school?.id ?? profile?.school?.id ?? null} />
    </ForYouShell>
  );
};
